import { FC, lazy } from 'react';

const Page = lazy(() => import('./page'));

export const Logout: FC = () => {
  return <Page />;
};
